/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Resolved kind of the chosen location: a fixed venue, an at_home service area, or an online room.
 */
export enum ProfessionalBookingBaseResponseLocationKind {
  venue = 'venue',
  at_home = 'at_home',
  online = 'online'
}
